<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">{{ $t("CATEGORIES.ADD_CATEGORY") }}</h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <category-form
              :loading="loading"
              :categoryData="category"
              :formErrors="formErrors"
              @categorySubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import { Option, Select } from "element-ui";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultCategory from "./defaultCategory";
import CategoryForm from "./partials/CategoryForm.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    CategoryForm,
  },

  mixins: [alertLeave],

  data() {
    const category = cloneDeep(defaultCategory);
    return {
      category: category,
      formErrors: null,
      loading: false,
    };
  },

  methods: {
    goBack() {
      this.$router.push({ name: "List Categories" });
    },

    viewCategory(category) {
      this.alertLeave = false;
      this.$router.push({
        name: "View Category",
        params: { id: category.id },
      });
    },

    async handleSubmit(category) {
      this.loading = true;
      const categoryData = cloneDeep(category);

      try {
        await this.$store.dispatch("categories/add", categoryData);
        this.$notify({
          type: "success",
          message: this.$t("CATEGORIES.CATEGORY_ADDED"),
        });
        const category = await this.$store.getters["categories/category"];
        this.viewCategory(category);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
